export default __webpack_public_path__ + "static/media/yuva_Teja.2610b228.jpeg";